import type { QuotationInvoicePaymentKind } from "./types";

const AMOUNT_EPS = 0.005;

/**
 * ກຳນົດ kind ອັດຕະໂນມັດຕາມຍອດກ່ອນ/ຫຼັງບັນທຶກ — ໃຊ້ທັງ UI ແລະ POST /my/:id/payments
 */
export function inferPaymentKindForInvoice(params: {
  netBefore: number;
  amount: number;
  documentTotal: number;
  isRefund: boolean;
}): QuotationInvoicePaymentKind {
  if (params.isRefund) return "refund";
  const projected = params.netBefore + params.amount;
  if (projected >= params.documentTotal - AMOUNT_EPS) return "final";
  if (params.netBefore <= AMOUNT_EPS) return "deposit";
  return "partial";
}

export function paymentKindLabel(kind: QuotationInvoicePaymentKind): string {
  const map: Record<QuotationInvoicePaymentKind, string> = {
    deposit: "ມັດຈຳ / ງວດທຳອິດ",
    partial: "ຊຳລະບາງສ່ວນ",
    final: "ຊຳລະຄົບງວດ",
    refund: "ຄືນເງິນ",
  };
  return map[kind];
}
